import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import { protectedResources } from "../authConfig";

export async function getAccessToken(theAccounts: AccountInfo[], theInstance: IPublicClientApplication): Promise<string> { 
    let accessPromise = await theInstance.acquireTokenSilent({account: theAccounts[0], scopes: protectedResources.api.scopes});
    return accessPromise.accessToken;
}